<template>
<section>

    <div class="alert alert-danger alert-with-icon alert-dismissible fade show m-0 mb-3" data-notify="container" v-if="showAlert">
        <button type="button" aria-hidden="true" class="close" data-dismiss="alert" aria-label="Close">
            <i class="nc-icon nc-simple-remove"></i>
        </button>
        <span data-notify="icon" class="nc-icon nc-alert-circle-i"></span>
        <span data-notify="message">Storage limit is approaching.</span>
    </div>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-md-4">
                    <h4 class="card-title">Email</h4>
                    <select class="form-control" v-model="selectedDomain">
                        <option v-for="(account, index) in hostingAccounts" :value="index" :key="index + '_' + account.domain">
                            {{account.domain}}
                        </option>
                    </select>
                </div>
                <div class="col-md-2">
                    <br>
                    <button class="btn btn-info btn-sm pull-left mt-5" v-if="!accountFlag" @click="setupEmail()">
                        Setup Email
                    </button>
                </div>
                <div class="col-md-6">
                    <section style="display: flex" class="pull-right">
                        <div style="width: 250px" >
                            <canvas id="chartDonut1" class="pull-right ct-chart ct-perfect-fourth"></canvas>
                        </div>

                        <div>
                            <button class="btn btn-primary btn-sm pull-right mt-5" @click="openNewEmailModal()">
                                Add New Email
                            </button>
                        </div>
                    </section>
                </div>
            </div>
            <hr>
        </div>
        <div class="card-body  mb-5 pt-5" v-if="accountFlag && !accountLoading">
            <ul class="nav nav-pills nav-pills-primary nav-pills-icons justify-content-center mb-2" role="tablist">
                <li class="nav-item">
                    <a :class="{'nav-link': true, 'active': currentTab === 'email_accounts'}" data-toggle="tab" href="#email_accounts" @click="changeTab('email_accounts')">
                        Email Accounts
                    </a>
                </li>
                <li class="nav-item">
                    <a :class="{'nav-link': true, 'active': currentTab === 'forwarders'}" data-toggle="tab" href="#forwarders" @click="changeTab('forwarders')">
                        Forwarders
                    </a>
                </li>
            </ul>
            <div class="tab-content tab-space tab-subcategories">
                <!-- Panel for the Email Accounts - START -->
                <div :class="{'tab-pane': true, 'active': currentTab === 'email_accounts'}" id="email_accounts">
                    <div class="" style="margin-top: 10px">
                            <div class="table-responsive">
                                <table class="table"  v-if="!loading">
                                    <thead class="text-primary">
                                    <tr>
                                        <th class="">Name</th>
                                        <th class="">Storage</th>
                                        <th class="text-center"></th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="all_emails.length>0">
                                    <tr v-for="(email,index) in all_emails" :key="index">
                                        <td class="">{{email.email}}</td>
                                        <td class="">
                                            <div class="progress" style="height: 12px; border-radius: 7px">
                                                <div class="progress-bar" :style="'width:'+email.diskusedpercent+'%; border-radius: 7px'"></div>
                                            </div>
                                            <div>
                                                <span class="pull-left"><small>Used: {{ (isNaN(email.diskquota))? email.diskused + 'MB / UNLIMITED' : email.diskused + 'MB / ' + (email.diskquota) + 'MB'}}</small></span><!--<span class="pull-right"><small>{{email.diskusedpercent}}%</small></span>-->
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <button class="btn btn-primary mr-2 btn-sm" v-on:click="checkEmail(index)"> Check Email</button>
                                            <button class="btn btn-success mr-2 btn-sm" v-on:click="openManagePopup(index)"> Manage</button>
                                            <button class="btn btn-info mr-2 btn-sm" v-on:click="openClientSetupPopup(index)">Client Setup</button>
                                            <button class="btn btn-warning mr-2 btn-sm" v-on:click="openMigratePopup(email)">Migrate</button>
                                            <button class="btn btn-danger btn-sm" style="margin: 0" @click="removeEmail(index)"><i class="fa fa-trash"></i></button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="loader" v-if="loading"></div>
                            <div class="row" v-if="!all_emails.length>0 && !loading">
                                <div class="col-md-12 text-center">
                                    <span class="text-primary">No emails for selected domain!</span>
                                </div>
                            </div>
                        </div>
                </div>
                <!-- Panel for the Email Accounts - END -->
                <!-- Panel for the Forwarders - START -->
                <div :class="{'tab-pane': true, 'active': currentTab === 'forwarders'}" id="forwarders">
                    <div class="loader" v-if="loading"></div>

<!--                    <div v-if="!loading" class="mt-3">-->
<!--                        <div class="row">-->
<!--                            <div class="col-md-12">-->
<!--                                <h4 class="text-primary">Domain Forwarders</h4>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="row">-->
<!--                            <div class="col-sm-4">-->
<!--                                <label>Domain</label>-->
<!--                                <select class="form-control" v-model="forwarder_domain.selectedDomain" v-on:change="frwrdrdomainChanged()" >-->
<!--                                    <option value="" disabled>Select The Domain</option>-->
<!--                                    <option v-for="(account, index) in hostingAccounts" :value="index" :key="index + '_' + account.domain">-->
<!--                                        {{account.domain}}-->
<!--                                    </option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                            <div class="col-sm-4">-->
<!--                                <label>Redirect to</label>-->
<!--                                <input type="text" class="form-control" required v-model.trim="forwarder_domain.redirect_to" style="width: 100%">-->
<!--                            </div>-->
<!--                            <div class="col-sm-4 text-center">-->
<!--                                <button class="btn btn-outline-primary mt-3" v-if="!domianforwarderLoading" :disabled="(forwarder_domain.selectedDomain ==='' || forwarder_domain.redirect_to ==='' )" v-on:click="addDomainForwarder()">-->
<!--                                    Add Domain Forwarder-->
<!--                                </button>-->
<!--                                <div class="loader" v-if="domianforwarderLoading" style="width: 35px;height: 35px ; margin-top: 1rem"></div>-->

<!--                            </div>-->
<!--                        </div>-->

<!--                                <hr>-->
<!--                        <div class="row mt-3">-->
<!--                            <div class="col-sm-12">-->
<!--                                <div class="table-responsive">-->
<!--                                    <table class="table">-->
<!--                                        <thead class="text-primary">-->
<!--                                        <tr>-->
<!--                                            <th class="">Domain</th>-->
<!--                                            <th class="">Redirect To</th>-->
<!--                                            <th class="text-center">Type</th>-->
<!--                                            <th class="text-center">Action</th>-->
<!--                                        </tr>-->
<!--                                        </thead>-->
<!--                                        <tbody>-->
<!--                                        <tr v-for="(domain,index) in all_forwarder_domain" :key="index">-->
<!--                                            <td class="">{{domain.dest}}</td>-->
<!--                                            <td class="">-->
<!--                                                {{domain.forward}}-->
<!--                                            </td>-->
<!--                                            <td class="text-center">-->
<!--                                               Domain-->
<!--                                            </td>-->
<!--                                            <td class="text-center">-->
<!--                                                <button class="btn btn-outline-primary btn-sm mr-2" style="margin: 0" @click="editDomainForwarder(index)"><i class="fa fa-pencil"></i></button>-->
<!--                                                <button class="btn btn-outline-danger btn-sm" style="margin: 0" @click="removeDomainForwarder(index)"><i class="fa fa-trash"></i></button>-->
<!--                                            </td>-->
<!--                                        </tr>-->
<!--                                        </tbody>-->
<!--                                    </table>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="row" v-if="all_forwarder_domain.length<=0">-->
<!--                            <div class="col-md-12 text-center">-->
<!--                                <span class="text-primary">No email forwarder available for this domain!</span>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <hr class="mt-5">-->
                    <div v-if="!loading" class="mt-3">
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="text-primary">Email Forwarders</h4>
                            </div>
                        </div>
                        <form v-on:submit.prevent="addEmailForwarder()">
                            <div class="row mt-3">
                                <div class="col-sm-4">
                                    <label>Email</label>
                                  <div class="input-group mb-3">
                                    <input type="text" class="form-control" required v-model.trim="forwarder_email.emailIndex" placeholder="Your Email">
                                    <div class="input-group-append" style="height: 38px">
                                      <span class="input-group-text">{{ '@'+this.hostingAccounts[this.selectedDomain].domain}}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                    <label>Redirect to</label>
                                    <input type="email" required class="form-control"  v-model.trim="forwarder_email.redirect_to" style="width: 100%">
                                </div>
                                <div class="col-sm-4 text-center" >
                                    <button type="submit" v-if="!emailforwarderLoading" class="btn btn-outline-primary mt-3" :disabled="(forwarder_email.emailIndex ==='' || forwarder_email.redirect_to ==='' )">
                                        Add Email Forwarder
                                    </button>
                                    <div class="loader" v-if="emailforwarderLoading" style="width: 35px;height: 35px ; margin-top: 1rem"></div>

                                </div>
                            </div>
                        </form>
                        <div class="row">
                            <div class="col-md-12">
                                <hr>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead class="text-primary">
                                        <tr>
                                            <th class="">Email</th>
                                            <th class="">Redirect To</th>
                                            <th class="">Type</th>
                                            <th class="">Action</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="all_forwarder_email.length>0">
                                        <tr v-for="(email,index) in all_forwarder_email" :key="index">
                                            <td class="">{{email.dest}}</td>
                                            <td class="">
                                                {{email.forward}}
                                            </td>
                                            <td class="">
                                                Email
                                            </td>
                                            <td class="">
<!--                                                    <button class="btn btn-outline-primary btn-sm mr-2" style="margin: 0" @click="editEmailForwarder(index)"><i class="fa fa-pencil"></i></button>-->
                                                <button class="btn btn-outline-danger btn-sm" style="margin: 0" @click="removeEmailForwarder(index)"><i class="fa fa-trash"></i></button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="all_forwarder_email.length<=0">
                            <div class="col-md-12 text-center">
                                <span class="text-primary">There are currently no email forwarders setup.</span>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- Panel for the Forwarders - END -->
            </div>
        </div>
        <div class="card-body text-center" v-if="!accountLoading && !accountFlag">
            <h5 class="text-danger">Require email setup for this domain.</h5>
        </div>
        <div class="card-body">
            <div class="loader" v-if="accountLoading "></div>
        </div>
    </div>
    <div class="stepModal lg position-relative">
        <div class="modal fade" id="newEmailModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="twoFAStepModal">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-primary" id="twoFAStepModalHeader">Add New Email Account</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <AddNewEmail/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="stepModal lg position-relative">
        <div class="modal fade" id="manageEmailModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="manageEmailModal">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-primary">Manage Email Account</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="!manageEmailLoading">
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <label>Storage Space <i  aria-hidden="true" class=" text-primary fa fa-question-circle" data-toggle="tooltip" data-placement="top" title="10GB is included between all email accounts for free, extra storage is $1/GB/mo. This does NOT count towards your WPO storage."></i></label>
                                <div class="form-inline">
                                    <div class="form-check-radio mr-3">
                                        <label class="form-check-label">
                                            <input class="form-check-input" v-model="manageEmail.storageType" type="radio" name="limited" id="manage_limited" value="limited">  Limited
                                            <span class="form-check-sign" for="manage_limited"></span>
                                        </label>
                                    </div>
                                    <div class="form-check-radio">
                                        <label class="form-check-label">
                                            <input class="form-check-input" v-model="manageEmail.storageType" type="radio" name="unlimited" id="manage_unlimited" value="unlimited">  Unlimited
                                            <span class="form-check-sign" for="manage_unlimited"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="manageEmail.storageType==='limited'">
                            <div class="col-md-12">
                                <div class="input-group mb-3">
                                    <input type="number" class="form-control" placeholder="" v-model="manageEmail.storage" >
                                    <div class="input-group-append" style="height: 38px">
                                        <span class="input-group-text">{{manageEmail.storageUnit}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button class="btn btn-primary  pull-right" @click.prevent="updateEmailSetting('qouta')">Update</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <hr>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <label>Security</label>
                                <div class="form-inline">
                                    <div class="form-check-radio mr-3">
                                        <label class="form-check-label">
                                            <input class="form-check-input" v-model="manageEmail.security" type="radio" name="password" id="manage_password" value="password">  Set Password Now
                                            <span class="form-check-sign" for="manage_password"></span>
                                        </label>
                                    </div>
<!--                                    <div class="form-check-radio">-->
<!--                                        <label class="form-check-label">-->
<!--                                            <input class="form-check-input" v-model="manageEmail.security" type="radio" name="alternate_email" id="manage_alternate_email" value="alternate_email">  Provide alternate email-->
<!--                                            <span class="form-check-sign" for="manage_alternate_email"></span>-->
<!--                                        </label>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3" v-if="manageEmail.security === 'password'">
                            <div class="col-md-12">
                                <label>Password</label>
                                    <password class="" :secureLength="8" v-model="manageEmail.password" autocomplete="off" defaultClass="form-control" :showPassword="true" :required="true" :badge="false" :requiredSpecialCharacter="false" />
                            </div>
                        </div>
                        <div class="row mt-3" v-if="manageEmail.security === 'alternate_email'">
                            <div class="col-md-12">
                                <label>Alternate Email</label>
                                <input type="email" class="form-control" v-model.trim="manageEmail.alternate_email">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button class="btn btn-primary  pull-right" @click.prevent="updateEmailSetting('password')">Update</button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" v-if="manageEmailLoading">
                        <div class="loader"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="stepModal lg position-relative">
        <div class="modal fade" id="domainFrwrdrEditModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="twoFAStepModal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-primary" id="domainFrwrdrEditModalHeader">Edit Domain Forwarder</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="!domianforwarderUpdating">
                        <div class="row">
                            <div class="col-md-12">
                                <label>Domain</label>
                                <input type="text" class="form-control" disabled  v-model="editDomainFrwrdr.domain" >
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <label>Redirect To</label>
                                <input type="text" class="form-control"   v-model="editDomainFrwrdr.redirect_to" >
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button class="btn btn-primary  pull-right" @click.prevent="updateDomainForwarder()">Update</button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" v-if="domianforwarderUpdating">
                        <div class="loader"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="stepModal lg position-relative">
        <div class="modal fade" id="clientSetupModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="twoFAStepModal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-primary" id="clientSetupHeader">Mail Client Manual Settings</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-4">
                                <label>Username:</label>
                            </div>
                            <div class="col-md-8">
                                {{settingsEmail}}
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Password:</label>
                            </div>
                            <div class="col-md-8">
                                <i>{{settingsPassword}}</i>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Incoming Server:</label>
                            </div>
                            <div class="col-md-8">
                                mail.scoots.email<br>
                                <span>IMAP PORT: 993</span>&nbsp;&nbsp;&nbsp;<span>POP3 PORT: 995</span>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Outgoing Server:</label>
                            </div>
                            <div class="col-md-8">
                                mail.scoots.email<br>
                                <span>SMTP PORT: 587</span>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <span>IMAP, POP3, and SMTP require authentication.</span>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <span class="badge badge-info">For more info</span>
                            </div>
                        </div>
                        <ul class="list-unstyled">
                            <li><a target="_blank" href="https://help.bigscoots.com/en/articles/512468-use-gmail-for-your-email-hosted-with-bigscoots">Use gmail for your email hosted with bigscoots</a></li>
                            <li><a target="_blank" href="https://help.bigscoots.com/en/articles/512497-configure-mail-app-on-iphone-to-work-with-bigscoots-email">Configure mail app on iphone to work with bigscoots email</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Migrate ref="migrateModal" />
</section>
</template>

<script>
    import {db} from "@/firebase/init";
    import Chart from 'chart.js';
    import tooltips from "../../../mixins/tooltips";
    import swal from "sweetalert2";
    import Password from "../Sites/ViewHostingDetails/Ftp/PasswordStrengthMeter";

    export default {
        name: "Emails",
        components: {
            Password,
            AddNewEmail: () =>
                import(/* webpackChunkName: "topNav" */ "./AddNewEmail.vue"),
            Migrate: () =>
                import(/* webpackChunkName: "topNav" */ "./Migrate.vue"),
        },
        mixins: [tooltips],
        data(){
            return{
                openEmailIndex:0,
                editDomainFrwrdr:{
                    domain:'',
                    redirect_to:''
                },
                settingsEmail:'',
                settingsDomian:'',
                domianforwarderUpdating:false,
                emailforwarderLoading:false,
                accountLoading:false,
                loading:false,
                selectedDomain:0,
                settingsPassword:'',
                domainUserName:'',
                manageEmail:{
                    security:'',
                    password:'',
                    alternate_email:'',
                    storageType:'password',
                    storage:1024,
                    storageUnit:'MB',
                },
                currentTab:'email_accounts',
                all_emails:[],
                all_forwarder_domain:[],
                all_forwarder_email:[],
                forwarder_domain:{
                    selectedDomain:'',
                    redirect_to:'',
                },
                forwarder_email:{
                    emailIndex:'',
                    redirect_to:'',
                },
                domianforwarderLoading:false,
                manageEmailLoading:false,
                showAlert:false,
                accountFlag:false
            }
        },
        computed: {
            hostingAccounts() {
                return this.$store.getters["hosting/accountsOrdered"];
            },
            userUId() {
                return this.$store.getters.getUID;
            },
        },
        watch:{
            selectedDomain: function () {
                this.checkDomainAccount();
            },
            hostingAccounts(){
                if(this.selectedDomain === '' || this.selectedDomain === undefined){
                    this.selectedDomain = 0;
                }
            }
        },
        mounted(){

        },
        async created(){
            if (this.hostingAccounts.length === 0) {
                await this.$store.dispatch("hosting/fetchAccounts");
            }
            this.checkDomainAccount();
            this.getStorage();
        },
        methods:{
            openMigratePopup (email) {
                this.$refs.migrateModal.load(email.email);
            },
            frwrdrdomainChanged(){
                this.domianforwarderLoading = true;
                db.collection('users').doc(this.userUId).get()
                    .then(async doc => {
                        if (!doc.data().allDomians || !doc.data().allDomians.includes(this.hostingAccounts[this.forwarder_domain.selectedDomain].domain)) {
                            this.selectedDomain = this.forwarder_domain.selectedDomain;
                            this.domianforwarderLoading = false;
                            this.forwarder_domain.selectedDomain = '';
                            this.forwarder_domain.redirect_to = '';
                        }else{
                            this.domianforwarderLoading = false;
                        }
                    });
            },
            async setupEmail(){
                // if(this.hostingAccounts[this.selectedDomain].status !== 'active'){
                //     return swal('Warning!', 'This domain is not active yet!', 'warning');
                // }
                this.accountLoading = true;
                let username = '';
                const resp = await db.collection('users').doc(this.userUId).get()
                username = (resp.data().emailUsernames && resp.data().emailUsernames.username) ? resp.data().emailUsernames.username : ''
                if (username !== '') {
                  let newDomain = this.hostingAccounts[this.selectedDomain].domain;
                  let splitedArray = newDomain.split('.');
                  let subDomian =splitedArray[0];
                  await this.$http.post('email/add-addon-domain',{
                    grant_type:'token',
                    newDomain:newDomain,
                    subDomian:subDomian,
                    username:username
                  });
                  let all_domains = [];
                  await db.collection('users').doc(this.userUId).get()
                      .then(async doc => {
                        all_domains = doc.data().allDomians || [];
                      });
                  all_domains.push(newDomain);
                  await db.collection("users").doc(this.userUId).update({
                    allDomians:all_domains,
                  });
                  this.accountLoading = false;
                  this.accountFlag = true;
                  this.getAllEmails();
                } else {
                  this.checkAccounts()
                }
            },
            async checkAccounts () {
              this.accountLoading = true;
              try {
                let resp = await this.$http.post('email/list-account',{
                  grant_type:'token',
                  domain:this.hostingAccounts[this.selectedDomain].domain,
                  searchType:'domain'
                });
                if(resp.data.msg.data){
                    const username = resp.data.msg.data.acct[0].user;
                    let all_domains=[];
                    all_domains.push(this.hostingAccounts[this.selectedDomain].domain);
                    await db.collection("users").doc(this.userUId).update({
                      emailSetupFlag: true,
                      emailUsernames: {
                        domain:this.hostingAccounts[this.selectedDomain].domain,
                        username
                      },
                      allDomians: all_domains,
                    });
                  this.accountFlag = true;
                  this.getAllEmails();
                } else {
                  await this.createAccount();
                }
              } catch (e) {
                console.log(e.toString())
              }
              this.accountLoading = false;
            },
            async createAccount () {
              this.accountLoading = true;
              let error = false
              try {
                let username = await this.generateUsername();
                const resp = await this.$http.post('email/create-account',{
                  grant_type:'token',
                  domain:this.hostingAccounts[this.selectedDomain].domain,
                  username:username
                });
                let all_domains=[];
                all_domains.push(this.hostingAccounts[this.selectedDomain].domain);
                if(resp.data.msg.includes('already exists')){
                  console.warn('This domain is already under some other domain which is not in WPO. So consider this domain primary for c-panel also... ');
                  const ownerResp = await this.$http.post('/email/find-owner', {
                    grant_type: 'token',
                    domain: this.hostingAccounts[this.selectedDomain].domain
                  });
                  username = ownerResp.data.split('\n')[1].trim();
                }else if (resp.data.msg !== 'Account Creation Ok') {
                  error = true
                  this.accountLoading = false;
                  swal('Error', resp.data.msg, 'error');
                }
                if (!error) {
                  await db.collection("users").doc(this.userUId).update({
                    emailSetupFlag: true,
                    emailUsernames: {
                      domain:this.hostingAccounts[this.selectedDomain].domain,
                      username:username
                    },
                    allDomians: all_domains,
                  });
                  this.accountFlag = true;
                  this.getAllEmails();
                }
              } catch (e) {
                console.log(e.toString())
                swal('Error','Error in initializing email setup!', 'error');
              }
              this.accountLoading = false;
            },
            generateUsername() {
                const characters = 'a-z,A-Z,0-9,#';
                const size = 12;
                let charactersArray = characters.split(',');
                let CharacterSet = '';
                let username = '';

                if( charactersArray.indexOf('a-z') >= 0) {
                    CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
                }
                for(let i=0; i < size; i++) {
                    username += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
                }
                return  username;
            },
            async checkDomainAccount(){
                this.accountLoading = true;
                let domain = this.hostingAccounts[this.selectedDomain].domain;
                let flag = false;
                await db.collection('users').doc(this.userUId).get()
                    .then(async doc => {
                        if(doc.data().allDomians && doc.data().allDomians.includes(domain)){
                            flag =true;
                        }
                    });
                if(flag){
                    this.accountFlag = true;
                    this.getAllEmails();
                }else{
                    this.accountFlag = false;
                }
                this.accountLoading = false;
            },
            checkEmail(index){
                this.$http.post('email/check-email',{
                    grant_type:'token',
                    email:this.all_emails[index].email,
                }).then(res=>{
                    window.open(res.data.data.url, '_blank');
                });
            },
            getStorage(){
                let percentage=0;
                db.collection('users').doc(this.userUId).get()
                    .then(async doc => {
                        if(doc.data().emailSetupFlag && doc.data().emailUsernames && doc.data().emailUsernames.username){
                            const resp = await this.$http.post('email/get-disk-usage', {
                                grant_type: 'token',
                                username:doc.data().emailUsernames.username
                            });
                            percentage = resp.data;
                        }
                        if(percentage>=75){
                            this.showAlert = true
                        }
                        this.drawChart(percentage.toFixed(2));
                    })
            },
            removeEmailForwarder(index){
                swal({
                    title: "Are you sure?",
                    text: `Are you sure to delete this domain forwarder?.`,
                    type: "question",
                    confirmButtonText: "Yes Proceed",
                    confirmButtonColor: "#6ACF98",
                    showCancelButton: true,
                    cancelButtonText: "No Thanks",
                    cancelButtonColor: "#EE8057"
                })
                    .then(async result => {
                        if(result.value){
                            this.$http.post('email/remove-email-forwarder',{
                                grant_type:'token',
                                username:this.domainUserName,
                                fullEmail:this.all_forwarder_email[index].dest,
                                frwrdToEmail:this.all_forwarder_email[index].forward,
                            }).then(()=>{
                                this.all_forwarder_email.splice(index,1);
                                swal('Success','Email forwarder has been Deleted!', 'success');
                            });
                        }
                    });
            },
            addEmailForwarder(){
              if(this.forwarder_email.emailIndex!==''&&this.forwarder_email.redirect_to!==''){
                  let arr = this.forwarder_email.redirect_to.split('@');
                  let arr1 = arr[1].split('.');
                  if(arr1.length>1){
                      this.emailforwarderLoading = true;
                      this.$http.post('email/add-email-forwarder',{
                          grant_type:'token',
                          domain:this.hostingAccounts[this.selectedDomain].domain,
                          username:this.domainUserName,
                          fullEmail:this.forwarder_email.emailIndex + '@' + this.hostingAccounts[this.selectedDomain].domain,
                          frwrdToEmail:this.forwarder_email.redirect_to,
                      }).then(()=>{
                          this.getAllEmailForwarder();
                          this.emailforwarderLoading = false;
                          this.forwarder_email.emailIndex = '';
                          this.forwarder_email.redirect_to = '';
                          swal('Success','Email forwarder has been added!', 'success');
                      }).catch(()=>{
                          this.emailforwarderLoading = false;
                          swal('Error',' Something went wrong!', 'error');
                      });
                  }else{
                      swal('Error','Please enter valid email address!', 'error');
                  }

              }
            },
            removeDomainForwarder(index){
                swal({
                    title: "Are you sure?",
                    text: `Are you sure to delete this domain forwarder?.`,
                    type: "question",
                    confirmButtonText: "Yes Proceed",
                    confirmButtonColor: "#6ACF98",
                    showCancelButton: true,
                    cancelButtonText: "No Thanks",
                    cancelButtonColor: "#EE8057"
                })
                    .then(async result => {
                        if(result.value){
                            this.$http.post('email/remove-domain-forwarder',{
                                grant_type:'token',
                                username:this.domainUserName,
                                domain:this.all_forwarder_domain[index].dest,
                            }).then(()=>{
                                this.all_forwarder_domain.splice(index,1);
                                swal('Success','Domain forwarder has been Deleted!', 'success');
                            });
                        }
                    });
            },
            closePopup(index = -1){
                console.log(index);
                $("#newEmailModal").modal('hide');
                if(index>=0){
                    this.selectedDomain = index;
                }else{
                    this.selectedDomain = 0;
                }
                this.checkDomainAccount();
            },
            async getAllEmails(){
                this.loading = true;
                db.collection('users').doc(this.userUId).get()
                    .then(async doc => {
                        this.domainUserName = doc.data().emailUsernames.username;
                        this.getAllEmailForwarder();
                        let resp = await this.$http.post('email/list-email-sh',{
                            grant_type:'token',
                            domain:this.hostingAccounts[this.selectedDomain].domain,
                            username:this.domainUserName,
                        });
                        this.all_emails = resp.data.result.data;
                        this.loading = false;
                    }).catch( () => {
                      this.all_emails = [];
                      this.loading = false;
                    });

            },
            drawChart(percentage){
                let ctx = document.getElementById('chartDonut1').getContext("2d");
                Chart.pluginService.register({
                    beforeDraw: (chart) => {
                        this.initChart(chart)
                    }
                });
                new Chart(ctx, {
                    type: 'pie',
                    data: {
                        labels: ['used', 'available'],
                        datasets: [{
                            label: "Storage",
                            pointRadius: 0,
                            pointHoverRadius: 0,
                            backgroundColor: ['#eaae2c', '#f4f3ef'],
                            borderWidth: 0,
                            data: [percentage, 100-percentage]
                        }]
                    },
                    options: {
                        elements: {
                            center: {
                                text: percentage+'%',
                                color: '#eaae2c', // Default is #000000
                                fontStyle: 'Arial', // Default is Arial
                                sidePadding: 20, // Defualt is 20 (as a percentage)
                                display:true
                            }
                        },
                        cutoutPercentage: 90,
                        legend: {
                            display: true
                        },
                        tooltips: {
                            enabled: false
                        },

                        scales: {
                            yAxes: [{

                                ticks: {
                                    display: false
                                },
                                gridLines: {
                                    drawBorder: false,
                                    zeroLineColor: "transparent",
                                    color: 'rgba(255,255,255,0.05)'
                                }

                            }],

                            xAxes: [{
                                barPercentage: 1.6,
                                gridLines: {
                                    drawBorder: false,
                                    color: 'rgba(255,255,255,0.1)',
                                    zeroLineColor: "transparent"
                                },
                                ticks: {
                                    display: false,
                                }
                            }]
                        },
                    }
                });
            },
            getAllEmailForwarder(){
                this.loading =true;
                this.$http.post('email/list-email-forwarder-sh',{
                    grant_type:'token',
                    domain:this.hostingAccounts[this.selectedDomain].domain,
                    username:this.domainUserName,
                }).then(resp=>{
                    try {
                        this.all_forwarder_email = resp.data.result.data;
                        this.loading =false;
                    }catch (e) {
                        this.all_forwarder_email = [];
                        this.loading =false;
                    }
                }).catch(()=>{
                  this.all_forwarder_email = [];
                  this.loading =false;
                });
            },
            getAllDomainForwarder(){
                this.loading =true;
                this.$http.post('email/list-domain-forwarder',{
                    grant_type:'token',
                    domain:this.hostingAccounts[this.selectedDomain].domain,
                    username:this.domainUserName,
                }).then(resp=>{
                    try {
                        const start = resp.data.indexOf('{') - 1;
                        const end = resp.data.lastIndexOf('}') + 1;
                        let response = resp.data.substring(start, end);
                        let parsedJsonResponse = JSON.parse(response);
                        this.all_forwarder_domain = parsedJsonResponse.result.data;
                        this.loading =false;
                    }catch (e) {
                        this.all_forwarder_domain = [];
                        this.loading =false;
                    }
                });
            },
            openManagePopup(index){
                this.openEmailIndex = index;
                $('#manageEmailModal').modal('show');
                $('.modal-backdrop').removeClass("modal-backdrop");
            },
            openClientSetupPopup(index){
                this.openEmailIndex = index;
                this.settingsDomian = this.all_emails[index].domain;
                this.settingsEmail = this.all_emails[index].email;
                this.settingsPassword = 'Your email password here!';
                db.collection('users').doc(this.userUId).get()
                    .then(async doc => {
                        if (doc.data().emailAccounts) {
                            for(let account of doc.data().emailAccounts){
                                if(account.email===this.all_emails[index].email){
                                    this.settingsPassword = account.password
                                }
                            }
                        }
                    });
                $('#clientSetupModal').modal('show');
                $('.modal-backdrop').removeClass("modal-backdrop");

            },
            openNewEmailModal(){
                $('#newEmailModal').modal('show');
                $('.modal-backdrop').removeClass("modal-backdrop");
            },
            changeTab(tab) {
                this.currentTab = tab;
            },
            addDomainForwarder(){
                if(this.forwarder_domain.selectedDomain!=='' && this.forwarder_domain.redirect_to!==''){
                    this.domianforwarderLoading = true;
                    this.$http.post('email/add-domain-forwarder',{
                        grant_type:'token',
                        domain:this.hostingAccounts[this.forwarder_domain.selectedDomain].domain,
                        username:this.domainUserName,
                        destDomian:this.forwarder_domain.redirect_to,
                    }).then(()=>{
                        this.getAllDomainForwarder();
                        this.domianforwarderLoading = false;
                        this.forwarder_domain.selectedDomain = '';
                        this.forwarder_domain.redirect_to = '';
                        swal('Success','Domain forwarder has been added!', 'success');
                    }).catch(()=>{
                        this.domianforwarderLoading = false;
                        swal('Error',' Something went wrong!', 'error');
                    });
                }
            },
            updateDomainForwarder(){
                if(this.editDomainFrwrdr.domain!=='' && this.editDomainFrwrdr.redirect_to!==''){
                    this.domianforwarderUpdating = true;
                    this.$http.post('email/add-domain-forwarder',{
                        grant_type:'token',
                        domain:this.editDomainFrwrdr.domain,
                        username:this.domainUserName,
                        destDomian:this.editDomainFrwrdr.redirect_to,
                    }).then(()=>{
                        this.getAllDomainForwarder();
                        this.domianforwarderUpdating = false;
                        this.editDomainFrwrdr.domain = '';
                        this.editDomainFrwrdr.redirect_to = '';
                        $('#domainFrwrdrEditModal').modal('hide');
                        swal('Success','Domain forwarder has been updated!', 'success');
                    }).catch(()=>{
                        this.domianforwarderUpdating = false;
                        swal('Error',' Something went wrong!', 'error');
                    });
                }
            },
            removeEmail(index){
                swal({
                    title: "Are you sure?",
                    text: `Are you sure to delete this email account?.`,
                    type: "question",
                    confirmButtonText: "Yes Proceed",
                    confirmButtonColor: "#6ACF98",
                    showCancelButton: true,
                    cancelButtonText: "No Thanks",
                    cancelButtonColor: "#EE8057"
                })
                    .then(async result => {
                        if(result.value){
                            this.$http.post('email/delete-email',{
                                grant_type:'token',
                                domain:this.hostingAccounts[this.selectedDomain].domain,
                                username:this.domainUserName,
                                email:this.all_emails[index].user,
                            }).then(async ()=>{
                                let emailAccounts=[];
                                await db.collection('users').doc(this.userUId).get()
                                    .then(async doc => {
                                        if (doc.data().emailAccounts) {
                                            emailAccounts = doc.data().emailAccounts;
                                        }
                                    });
                                for(let account of emailAccounts){
                                    if(account.email===this.all_emails[index].email){
                                        emailAccounts.splice(emailAccounts.indexOf(account),1);
                                    }
                                }
                                await db.collection("users").doc(this.userUId).update({
                                    emailAccounts: emailAccounts,
                                });
                                swal('Success','Email account has been deleted!', 'success');
                                this.all_emails.splice(index,1);
                            });
                        }
                    });
            },
            updateEmailSetting(section){
                if(section === 'password'){
                    if(this.manageEmail.password !== ''){
                        this.manageEmailLoading = true;
                        this.$http.post('email/change-password',{
                            grant_type:'token',
                            domain:this.hostingAccounts[this.selectedDomain].domain,
                            username:this.domainUserName,
                            email:this.all_emails[this.openEmailIndex].user,
                            password:this.manageEmail.password,
                        }).then(async(resp)=>{
                            let parsedJsonResponse = resp.data;
                            if(parsedJsonResponse.result.errors !== null){
                                swal('Error', parsedJsonResponse.result.errors[0], 'error');
                                this.manageEmailLoading = false;
                                this.manageEmail.password = '';
                                return;
                            }
                            console.log('No Error Found...');
                            let emailAccounts=[];
                            const doc = await db.collection('users').doc(this.userUId).get()
                            if (doc.data().emailAccounts) {
                              emailAccounts = doc.data().emailAccounts;
                            }
                            let accountFound = false
                            for(let account of emailAccounts){
                              if(account.email===this.all_emails[this.openEmailIndex].email){
                                account.password = this.manageEmail.password
                                accountFound = true
                              }
                            }
                            if (!accountFound) {
                              let obj={
                                email :this.all_emails[this.openEmailIndex].email,
                                password:this.manageEmail.password
                              };
                              emailAccounts.push(obj);
                            }
                            await db.collection("users").doc(this.userUId).update({
                                emailAccounts: emailAccounts,
                            });
                            this.manageEmailLoading = false;
                            this.manageEmail.password = '';
                            swal('Success','Password has been changed!', 'success');
                            $('#manageEmailModal').modal('hide');
                        });
                    }else{
                        swal('Error','Please enter Password!', 'error');
                    }
                }else{
                    if((this.manageEmail.storageType ==='limited' && this.manageEmail.storage!=='' || this.manageEmail.storageType ==='unlimited') && this.manageEmail.storageType !==''){
                        let storage = (this.manageEmail.storageType === 'limited')?this.manageEmail.storage:0;
                        this.manageEmailLoading = true;
                        this.$http.post('email/change-quota',{
                            grant_type:'token',
                            domain:this.hostingAccounts[this.selectedDomain].domain,
                            username:this.domainUserName,
                            email:this.all_emails[this.openEmailIndex].user,
                            storage:storage
                        }).then(()=>{
                            this.manageEmailLoading = false;
                            this.manageEmail.storage = '';
                            swal('Success','Quota has been changed!', 'success');
                            $('#manageEmailModal').modal('hide');
                        });
                    }else{
                        swal('Error','Storage is required!', 'error');
                    }

                }

            },
            editDomainForwarder(index){
                this.editDomainFrwrdr.domain = this.all_forwarder_domain[index].dest;
                this.editDomainFrwrdr.redirect_to = this.all_forwarder_domain[index].forward;
                $('#domainFrwrdrEditModal').modal('show');
                $('.modal-backdrop').removeClass("modal-backdrop");
            },
            initChart(chart) {
                if (chart.config.options.elements.center) {
                    //Get ctx from string
                    var ctx = chart.chart.ctx;
                    //Get options from the center object in options
                    var centerConfig = chart.config.options.elements.center;
                    var fontStyle = centerConfig.fontStyle || 'Arial';
                    var txt = centerConfig.text;
                    var color = centerConfig.color || '#000';
                    var sidePadding = centerConfig.sidePadding || 20;
                    var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)
                    //Start with a base font of 30px
                    ctx.font = "30px " + fontStyle;
                    //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
                    var stringWidth = ctx.measureText(txt).width;
                    var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;
                    // Find out how much the font can grow in width.
                    var widthRatio = elementWidth / stringWidth;
                    var newFontSize = Math.floor(30 * widthRatio);
                    var elementHeight = (chart.innerRadius * 2);
                    // Pick a new font size so it will not be larger than the height of label.
                    var fontSizeToUse = Math.min(newFontSize, elementHeight);
                    //Set font settings to draw it correctly.
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
                    var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
                    ctx.font = fontSizeToUse + "px " + fontStyle;
                    ctx.fillStyle = color;
                    //Draw text in center
                    ctx.fillText(txt, centerX, centerY);
                }
            }
        }
    }
</script>

<style scoped>
    .Password{
        max-width: 100% !important;
    }
</style>
